import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { SystemIconDirectiveModule } from '../../atoms/icon-directive/icon.directive';

@Component({
  selector: 'app-system-tabs',
  templateUrl: './tabs.component.html',
})
export class TabsComponent {
  @Input({
    required: true,
  })
  tabs: {
    icon: string;
    label: string;
    value: string;
  }[] = [];

  @Input() tabSelected = '';

  type!: string;

  @Output() activeTab = new EventEmitter<string>();
  constructor() {}

  changeTab(tab: string) {
    this.tabSelected = tab;
    this.activeTab.emit(tab);
  }
}

@NgModule({
  declarations: [TabsComponent],
  imports: [CommonModule, SystemIconDirectiveModule],
  exports: [TabsComponent],
})
export class SystemTabsModule {}
